const React = require('react');
const Col = require('./col');
const ReactDOM = require('react-dom');
import utils from 'utils/utils';
import $ from 'jquery';

module.exports = React.createClass({

	componentDidMount(){
		if (this.props.autofocus) {
			this.getNode().focus();
		}
	},

	getNode(){
		return ReactDOM.findDOMNode(this.refs.input);
	},

	propTypes: {
		size: React.PropTypes.string,
		label: React.PropTypes.string
	},

	handleChange(ev){
		if (typeof this.props.onChange == 'function') {
			this.props.onChange(ev);
		} else if (this.props.valueLink && typeof this.props.valueLink.requestChange == 'function') {
			var newValue = ev.target.value;
      if (this.props.upperCase) newValue = newValue.toUpperCase();
			this.props.valueLink.requestChange(newValue);
		}
	},

	focus(){
    var node = this.getNode();
    setTimeout(() => {
      node.focus();
      node.select();
    }, 300);
	},

	render(){
		var className = ((this.props.className) || 'form-control');
		var inputType = this.props.type || 'text';
		var value;

		if (this.props.valueLink) {
			value = this.props.valueLink.value || '';
		} else {
			value = this.props.value || '';
		}

		var props = utils.extend({},this.props);
		
		delete props.valueLink;
		delete props.onChange;
		delete props.value;
		delete props.type;

		return (
			<Col size={this.props.size} className='form-group'>
				<label className={this.props.labelClass}>{this.props.label}</label>
				<input ref='input' type={inputType} value={value} onChange={this.handleChange} className={className} {...props} /> 
			</Col>
		);
	}
});


/** WEBPACK FOOTER **
 ** ./src/components/form-input.js
 **/